<template>
  <div class="tConfig-page" ref="container">
		<div class="info-content">
			<div class="info-box">
				<div class="info-box-content">
					<div class="info-box-label" @click="pickTemperature('standbyWater')">
						<div class="label-name">待机水温</div>
						<div class="label-value">
							<div>最高{{priceConfig.standbyWater ? priceConfig.standbyWater.max : '--'}}℃ 最低{{priceConfig.standbyWater ? priceConfig.standbyWater.min : '--'}}℃</div>
							<div class="error-message" v-if="error.standbyWater">{{error.standbyWater}}</div>
						</div>
						<div class="iconfont icon-xiangyou"></div>
					</div>
					<div class="info-box-label" @click="pickTemperature('washWater')">
						<div class="label-name">洗烘水温</div>
						<div class="label-value">
							<div>最高{{priceConfig.standbyWater ? priceConfig.washWater.max : '--'}}℃ 最低{{priceConfig.standbyWater ? priceConfig.washWater.min : '--'}}℃</div>
							<div class="error-message" v-if="error.washWater">{{error.washWater}}</div>
						</div>
						<div class="iconfont icon-xiangyou"></div>
					</div>
					<div class="info-box-label" @click="pickTemperature('drySpace')">
						<div class="label-name">待机室温</div>
						<div class="label-value">
							<div>最高{{priceConfig.standbyWater ? priceConfig.drySpace.max : '--'}}℃ 最低{{priceConfig.standbyWater ? priceConfig.drySpace.min : '--'}}℃</div>
							<div class="error-message" v-if="error.drySpace">{{error.drySpace}}</div>
						</div>
						<div class="iconfont icon-xiangyou"></div>
					</div>
					<div class="info-box-label" @click="pickTemperature('standbySpace')">
						<div class="label-name">烘干室温</div>
						<div class="label-value">
							<div>最高{{priceConfig.standbyWater ? priceConfig.standbySpace.max : '--'}}℃ 最低{{priceConfig.standbyWater ? priceConfig.standbySpace.min : '--'}}℃</div>
							<div class="error-message" v-if="error.standbySpace">{{error.standbySpace}}</div>
						</div>
						<div class="iconfont icon-xiangyou"></div>
					</div>
					<div class="info-box-label" @click="pickTemperature('drySpacelast')">
						<div class="label-name">烘干室温</div>
						<div class="label-value">
							<div>剩余{{priceConfig.standbyWater ? priceConfig.drySpacelast.mins : '--'}}分钟后 最高{{priceConfig.standbyWater ? priceConfig.drySpacelast.max : '--'}}℃ 最低{{priceConfig.standbyWater ? priceConfig.drySpacelast.min : '--'}}℃</div>
							<div class="error-message" v-if="error.drySpacelast">{{error.drySpacelast}}</div>
						</div>
						<div class="iconfont icon-xiangyou"></div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="btnView">
			<div class="btn btn-save" @click="savePrice()">保存</div>
		</div>
		
		<Popup v-model="showPicker" position="bottom">
			<div class="tool-view">
				<div class="tool-btn cancel" @click="timeCancel">取消</div>
				<div class="tool-btn confirm" @click="timeConfirm">确认</div>
			</div>
			<div class="time-range-view">
				<div class="time" :class="setName =='mins' ? 'setting' : ''" @click="setTime('mins')" v-if="setIndex == 'drySpacelast'">分钟</div>
				<div class="time" :class="setName =='max' ? 'setting' : ''" @click="setTime('max')">最高</div>
				<div class="time" :class="setName =='min' ? 'setting' : ''" @click="setTime('min')">最低</div>
			</div>
			<Picker
				:show-toolbar="false"
				:columns="timeColumns"
				@change="timeChange"
				ref="picker"
			></Picker>
		</Popup>
		
	</div>
</template>
<script>
import PetApi from "../../api/petAdmin";
import { DatetimePicker, Popup, Picker, Toast} from 'vant';
export default {
  name: "PetAdminPriceConfig",
  components: {
		DatetimePicker,
		Popup,
		Picker,
		Toast
	},
  props: {},
  data: function() {
    return {
			setIndex : '',
			setValue : {},
			
			
			
			
			
			currentTime : "00:00",
			setName:'startTime',
			startTime : "00:00",
			endTime: "00:00",
			pickerTitle : '开始时间',
			showPicker : false,
			index : 0,
			deviceSn: this.$route.params.deviceSn,
			
			weekIndex : 0,
			showWeekPicker : false,
			columns : ['每天','周一','周二','周三','周四','周五','周六','周日'],
			
			timeColumns: [],
			timeIndex : [1,2,3],
			
			error : [],
			priceConfig : {},
			priceRuleTemp : {
				id : 0,
				timerange: '',
				dayrange: '',
				onlyPrice: '',
				allPrice: '',
				mini_onlyPrice: '',
				mini_allPrice: '',
				dry_unit_price: '',
				wash_unit_price: '',
				dayValue : '',
				timeValue : '',
				startTime : '00:00:00',
				endTime : '00:00:00',
			},
    }
  },
  watch: {
    "$route.params": function(newVal) {
      var that = this;
      if (newVal != undefined) {
    		that.deviceSn = newVal.deviceSn;
    		that.getInfo()
      }
    }
  },
  mounted: function() {
		this.getInfo();
  },
  computed: {
	},
  methods: {
		pickTemperature(index) {
			this.setIndex = index;
			if (index == "drySpacelast") {
				this.setName = "mins"
				this.setValue = this.priceConfig[index] ? { ...this.priceConfig[index] } : {mins : 0, max : 0, min : 0}
			} else {
				this.setName = "max"
				this.setValue = this.priceConfig[index] ? { ...this.priceConfig[index] } : {max : 0, min : 0}
			}
			this.setColumns();
			this.setTimeColumnsDefault(this.setValue[this.setName]);
			this.showPicker = true;
		},
		timeChange(picker, value, index) {
			this.setValue[this.setName] = value;
		},
		timeConfirm() {
			this.priceConfig[this.setIndex] = this.setValue;
			this.showPicker = false;
		},
		setTimeColumnsDefault(value) {
			this.$nextTick(() => {
				this.$refs.picker && this.$refs.picker.setIndexes([value - 1])
			})
		},
		setColumns() {
			let length = this.setName == "mins" ? 30 : 50;
			this.timeColumns = Array.from({ length: length }, (_, i) => i + 1);		
		},
		setTime(timeName) {
			this.setName = timeName;
			this.setColumns();
			let value = this.setValue[this.setName]
			this.setTimeColumnsDefault(value);
		},
		checkObjectValuesEmpty(obj) {
		  for (let key in obj) {
		    if (obj[key] === null || obj[key] === undefined || obj[key] === '' || obj[key] === 0) {
		      return false; // 如果值为空，则返回false
		    }
		  }
		  return true; // 如果所有值都不为空，则返回true
		},
		savePrice() {
			let that = this;
			let error = {};
			Object.keys(that.priceConfig).forEach(key => {
				if (!that.checkObjectValuesEmpty(that.priceConfig[key])) {
					error[key] = "请完整选择";
				}
			})
			
			if (Object.keys(error).length !== 0) return this.error = error;
			
			PetApi.petTemperatureSave({temperature : that.priceConfig, deviceSn : that.deviceSn}).then(
			  res => {
					that.$dialog.message(res.msg);
					that.error = [];
			  },
			  error => {
			    that.$dialog.message(error.msg);
					that.error = [];
			  }
			);
		},
		timeCancel() {
			this.showPicker = false;
		},
		getInfo() {
			let that = this;
			PetApi.petTemperatureGet(that.deviceSn).then(
			  res => {
					that.priceConfig = res.data;
			  },
			  error => {
			    that.$dialog.message(error.msg);
			  }
			);
		}
  }
};
</script>
<style lang="scss">
body {background: #F9F9F9 !important;}
.tConfig-page {
	.info-content {
		padding: 0 0.32rem 3rem;
		.info-box {
			background: #FFFFFF;
			border-radius: .20rem;
			margin-top: 0.48rem;
			position: relative;
	
			.info-box-content {
				padding: 0 0.3rem;
				
				.info-box-label {
					display: flex;
					justify-content: space-between;
					height: 1rem;
					align-items: center;
					
					&:not(:last-child) {
						border-bottom: 0.02rem solid #E8E8E8;
					}
					
					
					.label-name {
						font-weight: 400;
						font-size: .28rem;
						color: #000000;
						width: 1.5rem;
					}
					.label-value {
						font-weight: 400;
						font-size: .28rem;
						color: #999999;
						text-align: right;
						flex: 1;
						
						input {
							text-align: right;
						}
						
						.error-message {
							color: #ee0a24;
							font-size: 0.24rem;
						}
						
					}
					
					.iconfont {
						font-weight: 600;
						font-size: 0.28rem;
						margin-left: 0.12rem;
						color: #888888;;
					}
				}
			}
		
			.info-box-bottom {
				text-align: center;
				font-weight: bold;
				font-size: 0.28rem;
				color: #F5A100;
				border-top: 0.02rem solid #E8E8E8;
				padding: 0 0.3rem;
				
				.remove {
					padding: 0.3rem 0;
					span {
						padding: 0.1rem;
					}
				}
			}
		}
	}
	
	.btnView {
		width: 100%;
		position: fixed;
		bottom : 0rem;
		padding: 0.4rem 0.32rem 0;
		display: flex;
		justify-content: center;
		height: 2rem;
		background: #f9f9f9;
		.btn {
			height: 1rem;
			line-height: 1rem;
			border-radius: .50rem;
			text-align: center;
			font-weight: 400;
			font-size: .34rem;
			
			&.btn-add {
				border: 0.02rem solid #F5A100;
				color : #F5A100;
				width: 50%;
				margin-right: 0.2rem;
			}
			
			&.btn-save {
				background: #F5A100;
				color : #fff;
				flex : 1;
			}
		}
	}
}

.time-range-view {
	display: flex;
	justify-content: space-evenly;
	font-size: 0.32rem;
	font-weight: 500;
	align-items: center;
	.time {
		height: 1rem;
		line-height: 1rem;
		width: 2rem;
		text-align: center;
		color: #9E9E9E;
		
		&.setting {
			font-weight: bold;
			color: #000;
		}
	}
}
.tool-view {
	display: flex;
	justify-content: space-between;
	height: 0.88rem;
	align-items: center;
	.tool-btn {
		padding: 0 0.32rem;
		font-size: 0.28rem;
		line-height: 0.88rem;
		
		&.cancel {color: #969799;}
		&.confirm {color: #576b95;}
	}
}

.noCart {
	margin-top: 2rem;
	padding-top: 0.1rem;
}

.noCart .pictrue {
	width: 4rem;
	height: 3rem;
	margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
	width: 100%;
	height: 100%;
}

</style>
